import { useQuery } from '@tanstack/react-query';
import axios, { AxiosResponse } from 'axios';
import { HavePaginationEntity } from 'src/entities/HavePagination.entity';
import { SalesOrderResponseEntity as Entity } from 'src/entities/SalesOrder.response.entity';

const requestPathBase = '/api/v4/master/sales_orders';
export const queryKey = 'useSalesOrdersRequest';

const getResources = async (
  page: number,
  sortCondition: string,
  searchCondition: string,
  per?: number,
  groupBy?: string[]
) => {
  const requestParams = [
    `page=${page + 1}`,
    sortCondition ? `sort_condition=${sortCondition}` : '',
    searchCondition ? `${searchCondition}` : '',
    per ? `per=${per}` : '',
    groupBy ? groupBy.map((it) => `group_by[]=${it}`).join('&') : '',
  ].filter((maybe) => maybe).join('&');

  const requestPath = [
    requestPathBase,
    requestParams,
  ].join('?');

  const response: AxiosResponse<HavePaginationEntity<Entity>> = await axios.get<HavePaginationEntity<Entity>>(requestPath);

  return response.data;
};

export const useSalesOrdersRequest = (
  page: number,
  sortCondition: string,
  searchCondition: string,
  enabled: boolean,
  per?: number,
  groupBy?: string[],
) => useQuery(
  [queryKey, { page, sortCondition, searchCondition, per, groupBy }],
  () => getResources(page, sortCondition, searchCondition, per, groupBy),
  {
    staleTime: Infinity,
    enabled,
  }
);
